import { VehicleAttributeNames } from '../../../application/redux/options/optionsReducer';
import { EmissionClass, TollVehicleType } from '../../options/vehicle/VehicleAttributePresets';

const HEREVehicleAttributeNames = {
    TOLL_VEHICLE_TYPE: 'vehicle[type]',
    HEIGHT: 'vehicle[height]',
    LENGTH: 'vehicle[length]',
    WIDTH: 'vehicle[width]',
    LIMITED_WEIGHT: 'vehicle[grossWeight]',
    WEIGHT_PER_AXLE: 'vehicle[weightPerAxle]',
    VEHICLE_NUMBER_AXLES: 'vehicle[axleCount]',
    TRAILER_NUMBER_AXLES: 'vehicle[trailerAxleCount]',
    EMISSION_TYPE: 'tolls[emissionType]',
    SHIPPED_HAZARDOUS_GOODS: 'vehicle[shippedHazardousGoods]',
};

export type HEREVehicleAttributeNamesType = (typeof HEREVehicleAttributeNames)[keyof typeof HEREVehicleAttributeNames];

export const mapOption = (option: string): HEREVehicleAttributeNamesType => {
    if (option in HEREVehicleAttributeNames) {
        return HEREVehicleAttributeNames[option as keyof typeof HEREVehicleAttributeNames];
    }
    const key: HEREVehicleAttributeNamesType | undefined = (Object.entries(VehicleAttributeNames).find(
        value => value[1] === option
    ) ?? [undefined])[0];

    if (key) {
        return HEREVehicleAttributeNames[key as keyof typeof HEREVehicleAttributeNames];
    }

    throw Error(`Unknown vehicle attribute name: ${option}.`);
};

export const mapVehicleTypeValue = (tollVehicleType: TollVehicleType, isTrailer: boolean): string | undefined => {
    if (tollVehicleType === TollVehicleType.TRUCK) {
        if (isTrailer) {
            return 'Tractor';
        }
        return 'StraightTruck';
    }
    return;
};

export const mapEmissionTypeValue = (emissionType: EmissionClass): string | undefined => {
    switch (emissionType) {
        case EmissionClass.EURO_I:
            return 'euro1';
        case EmissionClass.EURO_II:
            return 'euro2';
        case EmissionClass.EURO_III:
            return 'euro3';
        case EmissionClass.EURO_IV:
            return 'euro4';
        case EmissionClass.EURO_V:
            return 'euro5';
        case EmissionClass.EURO_VI:
            return 'euro6';
        case EmissionClass.EURO_EEV:
            return 'euroEev';
        default:
            return;
    }
};
